// Aşama aşama geçen süre — kronolojik noktalar arasında GERÇEKTE geçen yıl/ay/gün + toplam gün.
// Motor çıktısından (timelineModel) beslenir; burada yeniden hesap yapılmaz, yalnız tarih farkı alınır.
// (zamanasimi-surec-haritasi.html'deki buildLegs mantığının sadık portu.)

import { tarihFarki } from './tarihHesaplamalari';

/** Tarih farkını her zaman (erken → geç) yönünde alır (negatif süre üretmez). */
const fark = (a, b) => (a <= b ? tarihFarki(a, b) : tarihFarki(b, a));

/** {yil,ay,gun} → "2 yıl 6 ay" / "0 gün". Ekran ve rapor ortak kullanır. */
export function farkMetni(f) {
  if (!f) return '0 gün';
  const p = [];
  if (f.yil) p.push(`${f.yil} yıl`);
  if (f.ay) p.push(`${f.ay} ay`);
  if (f.gun) p.push(`${f.gun} gün`);
  return p.join(' ') || '0 gün';
}

/**
 * @param {object} sonuc hesaplaZamanAsimi çıktısı
 * @returns {Array<{fromLabel, toLabel, ref, fark:{yil,ay,gun,gunSayisi}, accent?, doldu?}>}
 */
export function buildAsamalar(sonuc) {
  if (!sonuc || !sonuc.timelineModel) return [];
  const tm = sonuc.timelineModel;
  const suc = new Date(tm.sucTarihi);
  const bugun = new Date(sonuc.bugun);
  const effective = new Date(sonuc.effective);
  const doldu = !!sonuc.zamanAsimiDoldu;

  // Kronolojik noktalar: suç + etkili kesmeler + her durmanın başlangıç/bitişi
  const noktalar = [{ d: suc, label: 'Suç işlendi', ref: 'TCK 66/6' }];
  (tm.kesmeler || [])
    .filter((k) => k.effective)
    .forEach((k) =>
      noktalar.push({ d: new Date(k.date), label: k.label || k.type || 'Kesme', ref: 'TCK 67/2' })
    );
  (tm.durmalar || []).forEach((dd) => {
    noktalar.push({
      d: new Date(dd.start),
      label: 'Durma başladı — ' + (dd.label || dd.type || 'durma'),
      ref: 'TCK 67/1',
    });
    noktalar.push({ d: new Date(dd.end), label: 'Durma sona erdi', ref: 'TCK 67/1' });
  });
  noktalar.sort((a, b) => a.d - b.d);

  const satirlar = [];
  for (let i = 1; i < noktalar.length; i++) {
    satirlar.push({
      fromLabel: noktalar[i - 1].label,
      toLabel: noktalar[i].label,
      ref: noktalar[i].ref,
      fark: fark(noktalar[i - 1].d, noktalar[i].d),
    });
  }

  // Son olay → bugün
  const son = noktalar[noktalar.length - 1];
  satirlar.push({ fromLabel: son.label, toLabel: 'Bugün', ref: '', fark: fark(son.d, bugun) });

  // Bugün → etkin tarih (kalan ya da — dolmuşsa — geçen süre)
  satirlar.push({
    fromLabel: 'Bugün',
    toLabel: doldu ? 'Zamanaşımı doldu' : 'Geçerli zamanaşımı tarihi',
    ref: '',
    fark: fark(bugun, effective),
    accent: true,
    doldu,
  });

  return satirlar;
}
